(function () {
    'use strict';

    angular
        .module('app.completionTypes')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'completiontypes',
                  config: {
                      abstract: true,
                      url: '/completiontypes',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.userType() == "0") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'completiontypes.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/completiontypes/list.html?v=' + opsIncludeVersion,
                    controller: 'CompletionTypesListController',
                    controllerAs: 'vm',
                    title: 'Completion Types'
                }
            },
            {
             state: 'completiontypes.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/completionTypes/details.html?v=' + opsIncludeVersion,
                 controller: 'CompletionTypeDetailController',
                 controllerAs: 'vm',
                 title: 'Completion Type',
                 settings: {}
             }
            }
          
        ];
    }
})();
